import Configuration from '../config';

export async function calibrationRequest(fieldId, token, suffix = '', options = {}) {
  const response = await fetch(`${Configuration.apiEndPoint}/partners/fields/${fieldId}/camera-calibration${suffix}`, {
    ...options,
    headers: {Authorization: `Bearer ${token}`, 'Content-Type': 'application/json'},
    cache: 'no-store'
  });
  if (suffix.endsWith('/image') && response.ok) return response.blob();
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'request_failed');
  return result;
}

// Contract for the future player. Points are [x,y] in the original photo pixels.
export function saveCameraCalibration(fieldId, token, snapshot, values) {
  return calibrationRequest(fieldId, token, '', {
    method: 'PUT',
    body: JSON.stringify({snapshotId: snapshot.id, baseRevision: snapshot.configRevision, values})
  });
}
